module.exports = __webpack_public_path__ + "assets/img/hero-graph.d1737178.png";